/* istanbul ignore file - better tested visually */
import StepConnector from '@mui/material/StepConnector';
import Stepper, { StepperProps } from '@mui/material/Stepper';
import { classNames } from '@partful/shared/lib/classNames';
import { forwardRef } from 'react';
import styles from './VerticalStepper.module.scss';

export type VerticalStepperProps = Omit<StepperProps, 'orientation' | 'connector'>;

/**
 * A step component that is forced into a vertical orientation.
 */
export const VerticalStepper = forwardRef<HTMLDivElement, VerticalStepperProps>((props, ref) => (
  <Stepper
    {...props}
    orientation="vertical"
    connector={<StepConnector classes={{ root: classNames(styles.connector) }} />}
    ref={ref}
  />
));
